export default {
    title: 'Notatki',
    subtitle: '{n} notatka | {n} notatki | {n} notatek',
    newNote: 'Nowa notatka',
    search: 'Szukaj w notatkach',
    searchPlaceholder: 'Szukaj w notatkach…',
    filters: {
        title: 'Filtry',
        pinned: 'Tylko przypięte',
        select: 'Zaznacz wiele',
    },
    sort: {
        title: 'Sortowanie: {sort}',
        newest: 'Najnowsze',
        oldest: 'Najstarsze',
        alpha: 'Alfabetycznie (A–Z)',
        short: {
            newest: 'Najnowsze',
            oldest: 'Najstarsze',
            alpha: 'A–Z',
        },
    },
    capture: {
        placeholder: 'Zanotuj coś…',
        hint: 'Enter zapisuje · Shift+Enter nowa linia · pierwsza linia to tytuł',
        save: 'Zapisz',
    },
    list: {
        pinned: 'Przypięta',
        untitled: 'Bez tytułu',
        yesterday: 'wczoraj',
        sections: '{done} z {total}',
        links: '{n} link | {n} linki | {n} linków',
    },
    empty: {
        noMatchTitle: 'Nic nie pasuje do szukanej frazy',
        noMatchText: 'Zmień frazę albo wyczyść pole szukania.',
        noPinnedTitle: 'Brak przypiętych notatek',
        noPinnedText: 'Przypnij notatkę pinezką na jej pasku albo wyłącz filtr „Tylko przypięte".',
        title: 'Notatnik jest pusty',
        text: 'Wpisz coś w polu powyżej — kod do bramy, listę książek, piosenki z linkami.',
    },
    categories: {
        title: 'Kategorie',
        all: 'Wszystkie',
        none: 'Bez kategorii',
        add: 'Nowa kategoria',
        pick: 'Kategoria',
        edit: 'Zmień kategorię „{name}"',
        name: 'Nazwa kategorii',
        namePlaceholder: 'np. Muzyka, Książki, Dom',
        color: 'Kolor',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń',
        removed: 'Usunięto kategorię „{name}" — notatki zostały',
    },
    archive: {
        title: 'Archiwum',
        back: 'Wróć do notatek',
        open: 'Archiwum ({n})',
        empty: 'Archiwum jest puste',
    },
    pick: {
        title: 'Wybierz notatkę',
        text: 'Albo zacznij nową — przyciskiem „Nowa notatka" albo w polu „Zanotuj coś…" nad listą.',
    },
    toolbar: {
        back: 'Wróć do listy',
        pin: 'Przypnij',
        unpin: 'Odepnij',
        archive: 'Do archiwum',
        restore: 'Przywróć z archiwum',
        remove: 'Usuń',
        inArchive: 'W archiwum',
        saving: 'Zapisywanie…',
        saveError: 'Nie udało się zapisać — spróbujemy przy następnej zmianie',
        edited: 'Edytowano {when}',
    },
    toast: {
        removed: 'Usunięto notatkę',
        archived: 'Przeniesiono do archiwum',
        restored: 'Przywrócono z archiwum',
        undo: 'Cofnij',
    },
    select: {
        toolbar: 'Zaznaczone notatki',
        count: 'Zaznaczono {n}',
        all: 'Zaznacz wszystkie widoczne',
        none: 'Odznacz wszystkie',
        move: 'Przenieś do kategorii',
        archive: 'Archiwizuj',
        restore: 'Przywróć',
        remove: 'Usuń',
        cancel: 'Anuluj',
        moved: 'Przeniesiono {n} notatkę do „{name}" | Przeniesiono {n} notatki do „{name}" | Przeniesiono {n} notatek do „{name}"',
        archived: 'Zarchiwizowano {n} notatkę | Zarchiwizowano {n} notatki | Zarchiwizowano {n} notatek',
        restored: 'Przywrócono {n} notatkę z archiwum | Przywrócono {n} notatki z archiwum | Przywrócono {n} notatek z archiwum',
        confirmTitle: 'Usunąć {n} notatkę? | Usunąć {n} notatki? | Usunąć {n} notatek?',
        removed: 'Usunięto {n} notatkę | Usunięto {n} notatki | Usunięto {n} notatek',
    },
    editor: {
        title: 'Tytuł',
        titlePlaceholder: 'Tytuł',
        content: 'Treść notatki',
        placeholder: 'Pisz… „## " to nagłówek, „- [ ] " to checkbox, wklejony link w pustej linii staje się guzikiem.',
        heading: 'Nagłówek',
        section: 'Sekcja do odhaczenia',
        bullet: 'Lista',
        task: 'Checkbox',
        link: 'Link',
        done: 'Gotowe',
        hint: 'Esc kończy edycję. Zapisuje się samo.',
    },
    reader: {
        empty: 'Pusta notatka — kliknij, żeby pisać.',
        collapse: 'Zwiń sekcję',
        expand: 'Rozwiń sekcję',
    },
    toc: {
        title: 'Spis',
        search: 'Szukaj w spisie',
        noMatch: 'Żaden nagłówek nie pasuje.',
        done: 'odhaczone {done} z {total}',
    },
    help: {
        capture: {
            title: 'Zanotuj coś',
            text: 'Najszybsza droga do notatki: wpisz i naciśnij Enter. Pierwsza linia zostaje tytułem, reszta treścią.',
            more: 'Shift+Enter robi nową linię. Notatka trafia do kategorii, którą akurat oglądasz. Dłuższą notatkę zaczniesz przyciskiem „Nowa notatka".',
        },
        categories: {
            title: 'Kategorie',
            text: 'Porządek zamiast jednej wielkiej listy: Muzyka, Książki, Dom… Wybierz kategorię, żeby zobaczyć tylko jej notatki.',
            more: 'Nową kategorię dodasz plusem przy nagłówku. Notatka jest w najwyżej jednej kategorii — ustawiasz ją na pasku otwartej notatki. Nazwę, kolor i usunięcie znajdziesz pod „…" przy kategorii (na telefonie: tapnij wybraną pigułkę jeszcze raz). Usunięcie kategorii zostawia notatki.',
        },
        list: {
            title: 'Twoje notatki',
            text: 'Przypięte są na górze, reszta według sortowania obok wyszukiwarki (domyślnie od ostatnio zmienianych). Szukaj po tytule i treści.',
            more: 'Przy notatce widać jej kategorię, odhaczone sekcje, checkboxy i linki. Pod ikoną suwaków są filtry: „Tylko przypięte", „Archiwum" (notatki, do których nie wracasz — nie giną, a lista jest krótsza) i „Zaznacz wiele", żeby przenieść, zarchiwizować albo usunąć kilka naraz (na komputerze też Ctrl/Cmd+klik, Shift+klik zaznacza zakres, na telefonie przytrzymaj notatkę).',
        },
        note: {
            title: 'Notatka',
            text: 'Kliknij w tekst, żeby pisać — zapisuje się samo. „## " robi nagłówek, „- [ ] " checkbox, a wklejony link w pustej linii staje się guzikiem.',
            more: 'Nagłówek z checkboxem („## [ ] Diuna") to sekcja do odhaczenia — przeczytana książka, nauczona piosenka. Przy 3 nagłówkach notatka dostaje spis z szukaniem, a sekcje da się zwijać. Przypinanie, archiwum i usuwanie (z „Cofnij") są na pasku u góry.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Notatniku',
            description: 'Miejsce na to, co chcesz zachować: kody, listy, pomysły, piosenki z linkami, książki do przeczytania. Bez terminów — rzeczy na konkretny dzień to zadania w Planerze.',
        },
        format: {
            title: 'Pisanie w notatce',
            description: 'Otwórz notatkę i kliknij w tekst. Nagłówki, listy i checkboxy dodasz z paska nad treścią; wklejony link w pustej linii staje się guzikiem z ikoną serwisu. Nagłówek z checkboxem to sekcja do odhaczenia, np. przeczytana książka.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    firstSteps: {
        note: {
            title: 'Pierwsza notatka',
            action: 'Zanotuj coś',
            what: 'Wpisz coś w pole „Zanotuj coś…" i naciśnij Enter — kod do bramy, pomysł na prezent.',
            why: 'To najszybsza droga: jedna linia i gotowe, a wrócisz do tego, kiedy zechcesz.',
        },
        category: {
            title: 'Kategoria',
            action: 'Dodaj kategorię',
            what: 'Załóż kategorię, np. Muzyka albo Książki, i przypisz do niej notatki.',
            why: 'Zamiast jednej długiej listy widzisz tylko to, czego szukasz.',
        },
        structure: {
            title: 'Notatka z nagłówkami albo checkboxami',
            action: 'Zacznij notatkę',
            what: 'Napisz notatkę z nagłówkami („## ") albo checkboxami („- [ ] ") — np. książki do przeczytania.',
            why: 'Nagłówki z checkboxem odhaczasz jak sekcje, a długa notatka dostaje spis z szukaniem.',
        },
        pinned: {
            title: 'Przypięta notatka',
            action: 'Przypnij notatkę',
            what: 'Otwórz notatkę, do której często wracasz, i kliknij pinezkę na pasku.',
            why: 'Przypięte są zawsze na górze listy.',
        },
    },
    links: {
        defaultLabel: 'Link',
        tabs: 'Taby',
        lyrics: 'Tekst',
        map: 'Mapa',
    },
};
